import authenticate from '@/middleware/authenticate'
import store from '@/store'

export default [
  {
    path: '/products',
    name: 'product',
    meta: { middleware: authenticate },
    component: () => import('@/pages/inventory/product/index.vue')
  },
  {
    path: '/products/create',
    name: 'product-create',
    meta: { middleware: authenticate },
    component: () => import('@/pages/inventory/product/create.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('product/dataBeforeCreate')
      next()
    }
  },
  {
    path: '/products/:id',
    name: 'product-edit',
    meta: { middleware: authenticate },
    component: () => import('@/pages/inventory/product/edit.vue'),
    props: route => ({ products: route.params.products }),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('product/dataBeforeCreate')
      let response = await store.dispatch('product/find', to.params.id)
      let { category, unit_measure, inventory_type, ...resource } = response.data
      to.params.products = resource
      next()
    }
  }
]
